document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.info-grid-gallery__item');
  const details = document.querySelectorAll('.info-grid-gallery__detail');

  function showDetail(index) {
    details.forEach((d, i) => {
      d.style.display = i === index ? 'flex' : 'none';
    });

    items.forEach((item, i) => {
      item.classList.toggle('active', i === index);
    });
  }

  if (items.length > 0) {
    showDetail(0);
  }

  items.forEach((item, index) => {
    item.addEventListener('click', () => showDetail(index));
  });
});